import React from 'react';
import { FAQGlobalReference } from '../../../block-content/components/types/components/FAQGlobalReference/FAQGlobalReference';
import { FAQGlobalReferenceType } from '../../../../../../types/FAQGlobalReferenceType';

interface FAQGlobalReferenceBlockProps {
  block: FAQGlobalReferenceType;
}

export const FAQGlobalReferenceBlock = ({ block }: FAQGlobalReferenceBlockProps) => {
  if (!block) return null;
  return <FAQGlobalReference value={block} />;
};
